import { useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { http } from '../../AxiosConfig'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import pdfIcon from '../../asset/fileIcons/pdfIcon.png'
import noFileIcon from '../../asset/fileIcons/noFileIcon.png'
import zipIcon from '../../asset/fileIcons/zipIcon.png'
import fileIcon from '../../asset/fileIcons/fileIcon.png'
import FormLoader from '../FormLoader/FormLoader'
import parse from 'date-fns/parseISO'

const ReimbursementItemCard = ({ fetchReimbursment, item, reimb, index }) => {
  const dateFormatter = date => {
    const jsDate = parse(date)
    if (date) {
      const fff = format(jsDate, 'M/dd/yyyy')
      return fff
    }
    else {
      return ''
    }
  }

  const currency = new Intl.NumberFormat(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
    },
  )

  const showFieldsByType = () => {
    if (item.type === 'per_diem') {
      return [
        <div key={`perDiemStart-${item?.days}`} className="grid">
          <strong>Days:</strong> {Math.floor(item?.units)}
        </div>,
        <div key={`perDiemStart-${item?.per_diem_start}`} className="grid">
          <strong>Per diem Start:</strong>
          {dateFormatter(item?.per_diem_start)}
        </div>,
        <div key={`perDiemStart-${item?.per_diem_end}`} className="grid">
          <strong>Per diem End:</strong>
          {dateFormatter(item?.per_diem_end)}
        </div>,
      ]
    }
    else if (item.type === 'reimbursement') {
      return (
        (
          <div className="grid text-white">
            <strong>Receipt Amount:</strong>
            {currency.format(item.amount)}
          </div>
        ),
        (
          <div className="grid">
            <strong>Category:</strong>
            {item?.category?.replace('_', ' ')}
          </div>
        ),
        (
          <div className="grid">
            <strong>Quantity:</strong>
            {item?.units}
          </div>
        )
      )
    }
    else if (item.type === 'mileage') {
      return (
        <div className="grid">
          <div>
            <strong>Miles:</strong>
          </div>
          <div>{item?.units}</div>
        </div>
      )
    }
  }
  const deleteItem = () => {
    http
      .delete(`/reimbursement_items/${item.id}`)
      .then(res => {
        if (res.data) {
          toast.success(res.data.message)
        }
      })
      .catch(err => {
        console.log('delete item err:', err.message)
        toast.error('Could not Delete this Item .')
      })
      .finally(() => {
        fetchReimbursment()
      })
  }

  const showReceipt = () => {
    const theFiles = item.receipts
    if (theFiles && theFiles.length > 0) {
      const imageReceipt = theFiles.map(file => {
        const fileExtension = file.file_type
        const hasValidExtension = ['jpg', 'jpeg', 'png', 'gif'].includes(
          fileExtension,
        )
        const hasFileExtension = ['pdf', 'zip', 'doc', 'xls', 'svg'].includes(
          fileExtension,
        )
        let htmlOutput
        if (hasValidExtension) {
          htmlOutput = (
            <div key={file.id} className=" grid mt-4">
              <a
                // id={`receipt-link-${index}`}
                target="_blank"
                className="receipt-link thumbnail"
                href={file.url}
                rel="noreferrer"
              >
                <img
                  // id={`item-img-${index}`}
                  src={file.url}
                  className="img-receipt rounded-lg"
                  alt="receipt"
                ></img>
              </a>
            </div>
          )
        }
        else if (hasFileExtension) {
          if (file.file_type === 'pdf') {
            htmlOutput = (
              <div key={file.id} className="grid mt-4">
                <a
                  // id={`receipt-link-${index}`}
                  target="_blank"
                  className="receipt-link thumbnail"
                  href={file.url}
                  rel="noreferrer"
                >
                  <img
                    // id={`item-img-${index}`}
                    src={pdfIcon}
                    alt="pdf icon"
                    className="img-receipt thumbnail"
                  />
                </a>
              </div>
            )
          }
          else if (file.file_type === 'zip') {
            htmlOutput = (
              <div key={file.id} className="grid mt-4">
                <a
                  target="_blank"
                  className="thumbnail"
                  href={file.url}
                  rel="noreferrer"
                >
                  <img
                    id={`item-img-${index}`}
                    src={zipIcon}
                    alt="pdf icon"
                    className="thumbnail"
                  />
                </a>
              </div>
            )
          }
          else {
            ;<div key={file.id} className="grid mt-4">
              <a
                target="_blank"
                className="thumbnail"
                href={file.url}
                rel="noreferrer"
              >
                <img src={fileIcon} alt="pdf icon" className="thumbnail" />
              </a>
            </div>
          }
        }
        return htmlOutput
      })
      return imageReceipt
    }
    else {
      return (
        <div>
          <img src={noFileIcon} alt="no file icon" className="thumbnail" />
        </div>
      )
    }
  }
  useEffect(() => {}, [])
  if (!item) {
    return <FormLoader message="Loading" />
  }
  return (
    <div className="mt-5">
      <Toaster position="top-center " reverseOrder={false} />
      <article className="card">
        <header className="dark no-wrap">
          <div id={`type-name-${index}`} className="grid text-white">
            <div>
              <strong className="capitalize">
                {item?.type?.replace('_', ' ')}
              </strong>
            </div>
            <span className="">{item.name}</span>
          </div>
          {item.type === 'per_diem' ? null : (
            <div className="grid text-white">
              <div>
                <strong id="date-html">Date of Transaction:</strong>
              </div>
              <div id={`item-expense-date-${index}`} className="p-l">
                {dateFormatter(item.expense_date)}
              </div>
            </div>
          )}
          <div className="grid text-white"></div>
        </header>
        {showFieldsByType()}
        <div className="grid text-white">
          <div id="reimbursement-item-notes">
            <strong>Notes:</strong>
          </div>
          <div
            id={`item-notes-${index}`}
            dangerouslySetInnerHTML={{ __html: item.notes }}
            className="p-l"
          />
        </div>
        <br></br>
        <div className="navigation">
          <div className="link-container flex">
            <strong>Receipt:</strong>
            <div className="help-tip">
              <p>Click on Icon to see full Image</p>
            </div>
          </div>
        </div>
        <div id={`item-receipts-${index}`} className="wrap">
          {showReceipt()}
        </div>
        <button
          id="delete-item-button"
          onClick={deleteItem}
          className="red-button"
        >
          Delete
        </button>
      </article>
    </div>
  )
}

ReimbursementItemCard.propTypes = {
  fetchReimbursment: PropTypes.func,
  item: PropTypes.func,
  reimb: PropTypes.func,
  index: PropTypes.func,
}
export default ReimbursementItemCard
